"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTAG_CFG_OVRD = exports.URL_UTAG_SYNC = exports.URL_UTAG = exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { sync: constants_1.SyncConfig.ASYNC, order: constants_1.OrderConfig.TOP };
exports.URL_UTAG = 'utag.js';
exports.URL_UTAG_SYNC = 'utag.sync.js';
exports.UTAG_CFG_OVRD = { noview: true };
//# sourceMappingURL=constants.js.map